export default {
  states: {
    success: 'Успешно!',
    error: 'Ошибка!',
  },
}
